import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import {
  Box,
  Card as MuiCard,
  CardContent,
  Divider as MuiDivider,
  Grid,
  Typography,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";

const Divider = styled(MuiDivider)(spacing);
const Card = styled(MuiCard)(spacing);

const HeroCard = styled(Card)`
  overflow: hidden;
  border-radius: 24px;
  background: linear-gradient(135deg, #10213a 0%, #7c2d12 52%, #f59e0b 100%);
  color: #fff;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.18);
`;

const SurfaceCard = styled(Card)`
  border-radius: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.18);
`;

const MetricPill = styled(Box)`
  padding: 12px 16px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.16);
  min-width: 180px;
`;

function Coupons() {
  return (
    <React.Fragment>
      <Helmet title="Cupones" />

      <HeroCard mb={6}>
        <CardContent>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="overline">Promociones</Typography>
              <Typography variant="h2" gutterBottom>
                Cupones
              </Typography>
              <Typography variant="body1">
                Centraliza descuentos, beneficios y mecanicas promocionales en
                un solo modulo listo para evolucionar.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container spacing={3} justifyContent="flex-end">
                <Grid item>
                  <MetricPill>
                    <Typography variant="caption">Cobertura</Typography>
                    <Typography variant="h5">Promocional</Typography>
                  </MetricPill>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </HeroCard>

      <SurfaceCard mb={6}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            Gestion de cupones
          </Typography>
          <Typography variant="body2" color="textSecondary">
            El acceso ya esta disponible en el sidebar. Esta vista puede servir
            como base para crear, segmentar y monitorear cupones canjeables.
          </Typography>

          <Divider my={5} />

          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <SurfaceCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Campanas activas
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Reserva este bloque para promociones vigentes, vigencia y
                    reglas de redencion.
                  </Typography>
                </CardContent>
              </SurfaceCard>
            </Grid>
            <Grid item xs={12} md={6}>
              <SurfaceCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Analitica
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Espacio preparado para mostrar cupones usados, conversion y
                    rendimiento por promocion.
                  </Typography>
                </CardContent>
              </SurfaceCard>
            </Grid>
          </Grid>
        </CardContent>
      </SurfaceCard>
    </React.Fragment>
  );
}

export default Coupons;
